export default "__VITE_ASSET__Dk_t11Ct__"